// extracted by mini-css-extract-plugin
module.exports = {"satRoot":"sabre-about-transformer_satRoot__X6TjB"};